export default {"src":"/_next/static/media/Affordable Urology Care in Pune.cfbcc433.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};